import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

class HelpModal extends Component {
  render() {
    return (
      <Modal
        dialogClassName="modal-90w"
        show={this.props.show}
        onHide={() => this.props.hide()}
      >
        <Modal.Body style={{ display: 'flow-root', height: '85vh' }}>
          <iframe
            title="PDF"
            src="/Images/Getting_Started_User_Guide_V3.1_GAP.pdf"
            frameBorder="0"
            width="100%"
            height="100%"
          ></iframe>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => this.props.hide()}
            bsStyle="danger"
            bsSize="small"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default HelpModal;
